// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AboutImport } from './routes/about'
import { Route as IndexImport } from './routes/index'
import { Route as TeamOverviewIndexImport } from './routes/team-overview/index'
import { Route as TableIndexImport } from './routes/table/index'
import { Route as TablePreviewIndexImport } from './routes/table-preview/index'
import { Route as SettingsIndexImport } from './routes/settings/index'
import { Route as QuickStartGuideIndexImport } from './routes/quick-start-guide/index'
import { Route as PadminIndexImport } from './routes/padmin/index'
import { Route as LoginIndexImport } from './routes/login/index'
import { Route as LinkedinProfilesIndexImport } from './routes/linkedin-profiles/index'
import { Route as ClosedBetaIndexImport } from './routes/closed-beta/index'
import { Route as AccountMonitoringIndexImport } from './routes/account-monitoring/index'
import { Route as TableTableIdImport } from './routes/table/$tableId'
import { Route as OauthProviderImport } from './routes/oauth/$provider'
import { Route as CompleteOnboardingTokenImport } from './routes/complete-onboarding/$token'
import { Route as AdminUserloginImport } from './routes/admin/user_login'

// Create/Update Routes

const AboutRoute = AboutImport.update({
  path: '/about',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const TeamOverviewIndexRoute = TeamOverviewIndexImport.update({
  path: '/team-overview/',
  getParentRoute: () => rootRoute,
} as any)

const TableIndexRoute = TableIndexImport.update({
  path: '/table/',
  getParentRoute: () => rootRoute,
} as any)

const TablePreviewIndexRoute = TablePreviewIndexImport.update({
  path: '/table-preview/',
  getParentRoute: () => rootRoute,
} as any)

const SettingsIndexRoute = SettingsIndexImport.update({
  path: '/settings/',
  getParentRoute: () => rootRoute,
} as any)

const QuickStartGuideIndexRoute = QuickStartGuideIndexImport.update({
  path: '/quick-start-guide/',
  getParentRoute: () => rootRoute,
} as any)

const PadminIndexRoute = PadminIndexImport.update({
  path: '/padmin/',
  getParentRoute: () => rootRoute,
} as any)

const LoginIndexRoute = LoginIndexImport.update({
  path: '/login/',
  getParentRoute: () => rootRoute,
} as any)

const LinkedinProfilesIndexRoute = LinkedinProfilesIndexImport.update({
  path: '/linkedin-profiles/',
  getParentRoute: () => rootRoute,
} as any)

const ClosedBetaIndexRoute = ClosedBetaIndexImport.update({
  path: '/closed-beta/',
  getParentRoute: () => rootRoute,
} as any)

const AccountMonitoringIndexRoute = AccountMonitoringIndexImport.update({
  path: '/account-monitoring/',
  getParentRoute: () => rootRoute,
} as any)

const TableTableIdRoute = TableTableIdImport.update({
  path: '/table/$tableId',
  getParentRoute: () => rootRoute,
} as any)

const OauthProviderRoute = OauthProviderImport.update({
  path: '/oauth/$provider',
  getParentRoute: () => rootRoute,
} as any)

const CompleteOnboardingTokenRoute = CompleteOnboardingTokenImport.update({
  path: '/complete-onboarding/$token',
  getParentRoute: () => rootRoute,
} as any)

const AdminUserloginRoute = AdminUserloginImport.update({
  path: '/admin/user_login',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      preLoaderRoute: typeof AboutImport
      parentRoute: typeof rootRoute
    }
    '/admin/user_login': {
      preLoaderRoute: typeof AdminUserloginImport
      parentRoute: typeof rootRoute
    }
    '/complete-onboarding/$token': {
      preLoaderRoute: typeof CompleteOnboardingTokenImport
      parentRoute: typeof rootRoute
    }
    '/oauth/$provider': {
      preLoaderRoute: typeof OauthProviderImport
      parentRoute: typeof rootRoute
    }
    '/table/$tableId': {
      preLoaderRoute: typeof TableTableIdImport
      parentRoute: typeof rootRoute
    }
    '/account-monitoring/': {
      preLoaderRoute: typeof AccountMonitoringIndexImport
      parentRoute: typeof rootRoute
    }
    '/closed-beta/': {
      preLoaderRoute: typeof ClosedBetaIndexImport
      parentRoute: typeof rootRoute
    }
    '/linkedin-profiles/': {
      preLoaderRoute: typeof LinkedinProfilesIndexImport
      parentRoute: typeof rootRoute
    }
    '/login/': {
      preLoaderRoute: typeof LoginIndexImport
      parentRoute: typeof rootRoute
    }
    '/padmin/': {
      preLoaderRoute: typeof PadminIndexImport
      parentRoute: typeof rootRoute
    }
    '/quick-start-guide/': {
      preLoaderRoute: typeof QuickStartGuideIndexImport
      parentRoute: typeof rootRoute
    }
    '/settings/': {
      preLoaderRoute: typeof SettingsIndexImport
      parentRoute: typeof rootRoute
    }
    '/table-preview/': {
      preLoaderRoute: typeof TablePreviewIndexImport
      parentRoute: typeof rootRoute
    }
    '/table/': {
      preLoaderRoute: typeof TableIndexImport
      parentRoute: typeof rootRoute
    }
    '/team-overview/': {
      preLoaderRoute: typeof TeamOverviewIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  AboutRoute,
  AdminUserloginRoute,
  CompleteOnboardingTokenRoute,
  OauthProviderRoute,
  TableTableIdRoute,
  AccountMonitoringIndexRoute,
  ClosedBetaIndexRoute,
  LinkedinProfilesIndexRoute,
  LoginIndexRoute,
  PadminIndexRoute,
  QuickStartGuideIndexRoute,
  SettingsIndexRoute,
  TablePreviewIndexRoute,
  TableIndexRoute,
  TeamOverviewIndexRoute,
])
